// extracted by mini-css-extract-plugin
module.exports = {"About":"about_About__dCpl5","hero":"about_hero__Qyyx1","imageCard":"about_imageCard__sM31P"};